import React from "react";
import { restrictIntialSpace } from "../../core/services/sharedService";
import { useLocation } from "react-router-dom";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { GetApiMethod } from "../../core/services/apiService";
interface dashboardCardContentProps {
  filterText?: any;
  onCallTypeSelect?: any;
  onFilter?: any;
  onClear?: any;
  onStart?: any;
  onEnd?: any;
  selectStart?: any,
  selectEnd?: any,
}

const FilterComponent = ({
  filterText, onCallTypeSelect, onFilter, onClear, onStart, onEnd, selectStart, selectEnd
}: dashboardCardContentProps) => {
  const location = useLocation();
  const [uniqueValues, setUniqueValues] = React.useState<any>({
    "type": [],
    "call_direction": [],
    "call_from": [],
    "call_to": [],
    "agent": [],
    "call_forward_to": [],
    "location": []
  });

  const capitalizeFirstLetter = (string: string) => {
    return string[0].toUpperCase() + string.slice(1);
  }

  React.useEffect(() => {
    if (location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") {
      const uniqueUrl: string = "tenant/voicemail";
      GetApiMethod(`${uniqueUrl}/get-unique-values`).then((res: any) => {
        let diffTypes: any = { "type": [], "call_direction": [], "call_from": [], "call_to": [], "location": [] };
        res.data.data.forEach((item: any) => {
          if (item.key && item.key === "call_direction") {
            diffTypes['call_direction'].push(item.values);
          }
          if (item.key && item.key === "call_from") {
            diffTypes['call_from'].push(item.values);
          }
          if (item.key && item.key === "call_to") {
            diffTypes['call_to'].push(item.values);
          }
          if (item.key && item.key === "location") {
            diffTypes['location'].push(item.values);
          }
        });
        setUniqueValues(diffTypes);
      })
    } else {
      const uniqueUrl: string = process.env.REACT_APP_ADMIN ===
        localStorage.getItem("event") ? "tenant/report" : "tenant/report/agent"
      GetApiMethod(`${uniqueUrl}/get-unique-values`).then((res: any) => {
        let diffTypes: any = { "type": [], "call_direction": [], "call_from": [], "call_to": [], "agent": [], "call_forward_to": [], "location": [] };
        res.data.data.forEach((item: any) => {
          if (item.key && item.key === "type") {
            diffTypes['type'].push(item.values);
          }
          if (item.key && item.key === "call_direction") {
            diffTypes['call_direction'].push(item.values.filter((item: any) => (item !== "conference call")));
          }
          if (item.key && item.key === "call_from") {
            diffTypes['call_from'].push(item.values);
          }
          if (item.key && item.key === "call_to") {
            diffTypes['call_to'].push(item.values);
          }
          if (item.key && item.key === "agent") {
            diffTypes['agent'].push(item.values);
          }
          if (item.key && item.key === "call_forward_to") {
            diffTypes['call_forward_to'].push(item.values);
          }
          if (item.key && item.key === "location") {
            diffTypes['location'].push(item.values);
          }
        });
        setUniqueValues(diffTypes);
      })
    }
  }, []);

  const customStyles = (location.pathname === "/admin_reports" || location.pathname === "/reports" || location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") ? "row mb-2 Search-filter-border" : "row mb-2";
  const customFormStyle = (location.pathname === "/admin_reports" || location.pathname === "/reports" || location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") ? "Search-filter-border-mobile date_filter_search_sec mb-2  " : "date_filter_search_sec mb-2";

  return (
    <>
      <form onSubmit={(e) => { e.preventDefault() }} className={customFormStyle}>
        <div className={customStyles}>
          {(location.pathname === "/admin_reports" || location.pathname === "/reports" || location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") &&
            <>
              <div className="col-sm-6 col-md-4 row mt-2">
                <div className="col-sm-4 col-md-4 m-1">
                  <label>From</label>
                </div>
                <div className="col-sm-7 col-md-7">
                  <DatePicker
                    showIcon
                    isClearable
                    selected={selectStart}
                    onChange={onStart}
                    showYearDropdown
                    showMonthDropdown
                    dateFormat="MM/dd/yyyy"
                    maxDate={selectEnd ? selectEnd : new Date()}
                    clearButtonTitle="clear"
                    className="form-control"
                    placeholderText="&#xf073;"
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-4 row mt-2">
                <div className="col-sm-4 col-md-3 m-1">
                  <label>To</label>
                </div>
                <div className="col-sm-7 col-md-8">
                  <DatePicker
                    showIcon
                    disabled={selectStart ? false : true}
                    isClearable={(selectEnd.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) ? false : true}
                    selected={selectEnd ? selectEnd.setHours(23, 59, 59, 999) : new Date()}
                    onChange={onEnd}
                    showYearDropdown
                    showMonthDropdown
                    dateFormat="MM/dd/yyyy"
                    minDate={selectStart}
                    maxDate={new Date()}
                    clearButtonTitle="clear"
                    className="form-control"
                    placeholderText="&#xf073;"
                  />
                </div>
              </div>

              <div className="col-sm-6 col-md-4 row mt-2">
                <div className="col-sm-4 col-md-3 m-1">
                  <label>Search</label>
                </div>

                <div className={(location.pathname === "/admin_reports" || location.pathname === "/reports" || location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") ? "col-sm-7 col-md-8" : ""}>
                  <input
                    id="search"
                    type="text"
                    placeholder="Search"
                    onKeyDown={(e) => { restrictIntialSpace(e) }}
                    defaultValue={filterText}
                    onChange={onFilter}
                    className="form-control"
                    name="filterText"
                  />
                </div>
              </div>


              <div className="col-sm-6 col-md-4 row mt-2">
                <div className="col-sm-4 col-md-4 m-1">
                  <label>Call Direction</label>
                </div>
                <div className="col-sm-7 col-md-7">
                  <select
                    className="form-control"
                    onChange={(e: any) => { onCallTypeSelect(e, 'filter_by_call_direction') }}
                  >
                    <option value="">Select</option>
                    {(uniqueValues?.call_direction[0]?.length > 0) && (uniqueValues?.call_direction[0]).map((items: any, i: number) => {
                      return <option key={i} value={items}>{capitalizeFirstLetter(items)}</option>
                    })}
                    <option value="missed calls aggregated">Missed Calls – Aggregated</option>
                  </select>
                </div>
              </div>

              {(location.pathname !== "/voicemail_reports" && location.pathname !== "/admin_voicemail_reports") &&
                <div className="col-sm-6 col-md-4 row mt-2">
                  <div className="col-sm-4 col-md-3 m-1">
                    <label>Call Type</label>
                  </div>
                  <div className="col-sm-7 col-md-8">
                    <select
                      className="form-control"
                      onChange={(e: any) => { onCallTypeSelect(e, 'filter_by_type') }}
                    >
                      <option value="">Select</option>
                      {(uniqueValues?.type[0]?.length > 0) && (uniqueValues?.type[0]).map((items: any, i: number) => {
                        return <option key={i} value={items}>{capitalizeFirstLetter(items)}</option>
                      })}

                    </select>
                  </div>
                </div>
              }

              <div className="col-sm-6 col-md-4 row mt-2">
                <div className="col-sm-4 col-md-3 m-1">
                  <label>Location</label>
                </div>
                <div className="col-sm-7 col-md-8">
                  <select
                    className="form-control"
                    onChange={(e: any) => { onCallTypeSelect(e, 'filter_by_location') }}
                  >
                    <option value="">Select</option>
                    {(uniqueValues?.location[0])?.length > 0 && Object.values(uniqueValues?.location[0]).map((items: any, i: number) => {
                      return <option key={items._id} value={items.name}>{capitalizeFirstLetter(items.name)}</option>
                    })}
                  </select>
                </div>
              </div>


              <div className="col-sm-6 col-md-4 row mt-2">
                <div className={(location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") ? "col-sm-4 col-md-3 m-1" : "col-sm-4 col-md-4 m-1"}>
                  <label>Call From</label>
                </div>
                <div className={(location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") ? "col-sm-7 col-md-8" : "col-sm-7 col-md-7"}>
                  <select
                    className="form-control"
                    onChange={(e: any) => { onCallTypeSelect(e, 'filter_by_call_from') }}
                  >
                    <option value="">Select</option>
                    {(uniqueValues?.call_from[0]?.length > 0) && (uniqueValues?.call_from[0]).map((items: any, i: number) => {
                      return (
                        items && (<option key={i} value={items}>{items}</option>)
                      )
                    })}
                  </select>
                </div>
              </div>

              <div className="col-sm-6 col-md-4 row mt-2">
                <div className={(location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") ? "col-sm-4 col-md-4 m-1" : "col-sm-4 col-md-3 m-1"}>
                  <label>Call To</label>
                </div>
                <div className={(location.pathname === "/voicemail_reports" || location.pathname === "/admin_voicemail_reports") ? "col-sm-7 col-md-7" : "col-sm-7 col-md-8"}>
                  <select
                    className="form-control"
                    onChange={(e: any) => { onCallTypeSelect(e, 'filter_by_call_to') }}
                  >
                    <option value="">Select</option>
                    {(uniqueValues?.call_to[0]?.length > 0) && (uniqueValues?.call_to[0]).map((items: any, i: number) => {
                      return <option key={i} value={items}>{items}</option>
                    })}
                  </select>
                </div>
              </div>

              {(location.pathname !== "/voicemail_reports" && location.pathname !== "/admin_voicemail_reports") &&
                <>
                  <div className="col-sm-6 col-md-4 row mt-2">
                    <div className="col-sm-4 col-md-3 m-1">
                      <label>Agent</label>
                    </div>
                    <div className="col-sm-7 col-md-8">
                      <select
                        className="form-control"
                        onChange={(e: any) => { onCallTypeSelect(e, 'filter_by_agent') }}
                      >
                        <option value="">Select</option>
                        {(uniqueValues?.agent[0]?.length > 0) && Object.values(uniqueValues?.agent[0]).map((items: any, i: number) => {
                          return <option key={items._id} value={items.name}>{capitalizeFirstLetter(items.name)}</option>
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="col-sm-6 col-md-4 row mt-2 mb-1 call_forward_number">
                    <div className="col-sm-4 col-md-4 m-1">
                      <label>Call Forward Number</label>
                    </div>
                    <div className="col-sm-7 col-md-7">
                      <select
                        className="form-control"
                        onChange={(e: any) => { onCallTypeSelect(e, 'filter_by_call_forward_to') }}
                      >
                        <option value="">Select</option>
                        {('call_forward_to' in uniqueValues && uniqueValues?.call_forward_to[0]?.length > 0) && (uniqueValues?.call_forward_to[0]).map((items: any, i: number) => {
                          return <option key={i} value={items}>{items}</option>
                        })}

                      </select>
                    </div>
                  </div>
                </>
              }
            </>
          }
          {
            (location.pathname !== "/admin_reports" && location.pathname !== "/reports" && location.pathname !== "/voicemail_reports" && location.pathname !== "/admin_voicemail_reports") &&
            <div className={(location.pathname === "/admin_reports" || location.pathname === "/reports") ? "col-sm-6 col-md-6" : ""}>
              <input
                id="search"
                type="text"
                placeholder="Search"
                onKeyDown={(e) => { restrictIntialSpace(e) }}
                defaultValue={filterText}
                onChange={onFilter}
                className="form-control"
                name="filterText"
              />
            </div>
          }
        </div>
      </form>
    </>
  )

};

export default FilterComponent;